var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('popover-position'),_c('popover-variant'),_c('popover-trigger'),_c('popover-option'),_c('popover-method'),_c('popover-event'),_c('popover-advance')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }